import { ErrorDisplay } from "@/components/ErrorBoundary/ErrorBoundary";
import { Button } from "@/components/ui/button";
import { useAuth0 } from "@auth0/auth0-react";

export function ErrorPage({
  title = "Error",
  message = "An unknownerror occurred",
}: {
  title: string;
  message: string;
}) {
  const { logout } = useAuth0();

  return (
    <ErrorDisplay
      title={title}
      message={message}
      footer={
        <Button
          onClick={() =>
            logout({
              logoutParams: { returnTo: window.location.origin },
            })
          }
        >
          Logout
        </Button>
      }
    />
  );
}

export default ErrorPage;
